import 'regenerator-runtime/runtime';
import { put, call, takeEvery, takeLatest,all } from 'redux-saga/effects';
import {
  addMarket,
  addRegion,
  editMarket,
  editRegion,
  getMarketById,
  getRegionById,
  searchRegion,
  getListRegion,
  getListMarket,
  getListMarketByRegion,
  getReportRegionList,
  getReportMarketList,
  setupRegionPoAWS,
  uploadRegionPoToS3,
  uploadRegionPoToServer,
  getRegionPo,
  downloadRegionPo,
  removeRegionPo
} from './api';
import * as RegionMarketActionType from './constants';
import * as NotifyActionType from '../Notification/constants';

export function* searchRegionAsync(action) {

  const result = yield call(searchRegion, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: RegionMarketActionType.SEARCH_REGION_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }

}

export function* addRegionAsync(action) {

  const result = yield call(addRegion, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RegionMarketActionType.SEARCH_REGION_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Region created' })
    ];
  } else {
    yield [
      put({ type: RegionMarketActionType.ADD_EDIT_REGION_MARKET_ERROR, data: { error: result.data, params: action.params.data } })
      // put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error })
    ];
  }
}

export function* addMarketAsync(action) {

  const result = yield call(addMarket, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RegionMarketActionType.SEARCH_REGION_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Market created' })
    ];
  } else {
    yield put({ type: RegionMarketActionType.ADD_EDIT_REGION_MARKET_ERROR, data: { error: result.data, params: action.params.data } });
    // yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* editRegionAsync(action) {

  const result = yield call(editRegion, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RegionMarketActionType.SEARCH_REGION_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: RegionMarketActionType.ADD_EDIT_REGION_MARKET_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* editMarketAsync(action) {

  const result = yield call(editMarket, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RegionMarketActionType.SEARCH_REGION_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: RegionMarketActionType.ADD_EDIT_REGION_MARKET_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* getRegionByIdAsync(action) {

  const result = yield call(getRegionById, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: RegionMarketActionType.GET_REGION_BY_ID_SUCCESS, data: result.data });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getMarketByIdAsync(action) {

  const result = yield call(getMarketById, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: RegionMarketActionType.GET_MARKET_BY_ID_SUCCESS, data: result.data });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getListRegionAsync(action) {

  const result = yield call(getListRegion, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: RegionMarketActionType.GET_LIST_REGION_SUCCESS, data: result.data });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
    if (action.callback) {
      action.callback();
    }
  }
}

export function* getReportRegionListAsync(action) {

  const result = yield call(getReportRegionList, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: RegionMarketActionType.GET_LIST_REGION_SUCCESS, data: result.data });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
    if (action.callback) {
      action.callback();
    }
  }
}

export function* getListMarketAsync(action) {

  const result = yield call(getListMarket, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: RegionMarketActionType.GET_LIST_MARKET_SUCCESS, data: result.data });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
    if (action.callback) {
      action.callback();
    }
  }
}

export function* getReportMarketListAsync(action) {

  const result = yield call(getReportMarketList, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: RegionMarketActionType.GET_LIST_MARKET_SUCCESS, data: result.data });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
    if (action.callback) {
      action.callback();
    }
  }
}

export function* getListMarketByRegionAsync(action) {

  const result = yield call(getListMarketByRegion, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: RegionMarketActionType.GET_LIST_MARKET_SUCCESS, data: result.data });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* setupRegionPoAWSAsync(action) {
  const result = yield call(setupRegionPoAWS, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({ type: RegionMarketActionType.SETUP_REGION_PO_AWS_SUCCESS, data: result.data });
    if (action.callback) { action.callback(); }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* uploadRegionPOToS3Async(action) {
  const paramsUpload = {
    regionId: action.params.regionId,
    file: action.params.file,
    config: action.params.config
  };
  yield call(uploadRegionPoToS3, paramsUpload, action.callback);
}

export function* uploadRegionPOToServerAsync(action) {
  const result = yield call(uploadRegionPoToServer, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({type: RegionMarketActionType.UPLOAD_REGION_PO_TO_SERVER_SUCCESS, data: result.data});
    if (action.callback) {action.callback(true, result.data);}
  } else {
    if (action.callback) {action.callback(false, result.data);}
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* getRegionPOAsync(action) {
  const result = yield call(getRegionPo, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({type: RegionMarketActionType.GET_REGION_PO_SUCCESS, data: result.data});
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* downloadRegionPOAsync(action) {
  yield call(downloadRegionPo, action.params, action.callback);
}

export function* removeRegionPOAsync(action) {
  const result = yield call(removeRegionPo, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: RegionMarketActionType.GET_REGION_PO_ASYNC,
        params: {
          regionId: action.params.id
        }
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Deleted' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export default function* WatchRegionMarket() {
  yield all([
    takeLatest(RegionMarketActionType.SEARCH_REGION_ASYNC, searchRegionAsync),
    takeLatest(RegionMarketActionType.GET_REGION_BY_ID_ASYNC, getRegionByIdAsync),
    takeLatest(RegionMarketActionType.GET_MARKET_BY_ID_ASYNC, getMarketByIdAsync),
    takeEvery(RegionMarketActionType.CREATE_MARKET_ASYNC, addMarketAsync),
    takeEvery(RegionMarketActionType.CREATE_REGION_ASYNC, addRegionAsync),
    takeEvery(RegionMarketActionType.UPDATE_REGION_ASYNC, editRegionAsync),
    takeEvery(RegionMarketActionType.UPDATE_MARKET_ASYNC, editMarketAsync),
    takeLatest(RegionMarketActionType.GET_LIST_REGION_ASYNC, getListRegionAsync),
    takeLatest(RegionMarketActionType.GET_LIST_MARKET_ASYNC, getListMarketAsync),
    takeLatest(RegionMarketActionType.GET_LIST_MARKET_BY_REGION_ASYNC, getListMarketByRegionAsync),
    takeLatest(RegionMarketActionType.GET_REPORT_REGION_LIST_ASYNC, getReportRegionListAsync),
    takeLatest(RegionMarketActionType.GET_REPORT_MARKET_LIST_ASYNC, getReportMarketListAsync),
    takeEvery(RegionMarketActionType.SETUP_REGION_PO_AWS_ASYNC, setupRegionPoAWSAsync),
    takeEvery(RegionMarketActionType.UPLOAD_REGION_PO_TO_S3_ASYNC, uploadRegionPOToS3Async),
    takeEvery(RegionMarketActionType.UPLOAD_REGION_PO_TO_SERVER_ASYNC, uploadRegionPOToServerAsync),
    takeEvery(RegionMarketActionType.GET_REGION_PO_ASYNC, getRegionPOAsync),
    takeEvery(RegionMarketActionType.DOWNLOAD_REGION_PO_ASYNC, downloadRegionPOAsync),
    takeEvery(RegionMarketActionType.REMOVE_REGION_PO_ASYNC, removeRegionPOAsync)
  ]);
}




// WEBPACK FOOTER //
// ./src/Region-Market/saga.js